import GeneralTipCard from "./GeneralTipCard";
import ColorLeaderBoard from "./ColorLeaderBoard";
import { NavLink, useParams } from "react-router-dom";

function ForOtherUserOnly() {
     const { username } = useParams();
  return (
    <div className=" w-full mx-auto  pb-[3rem]  grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* Left Panel - Tipping Interface */}
      <div className="space-y-6 w-full ">
        {/* Profile Card */}
        <div className=" flex justify-end  ">
          <ul className=" md:mt-8 mt-[4rem]  list-none  w-fit flex flex-nowrap items-center justify-center sm:gap-4 gap-1  [&>li_a]:text-nowrap [&>li_a]:text-[14px] [&>li_a]:font-medium [&>li_a]:leading-[17px] [&>li_a]:tracking-[-0.02em] [&>li_a]:text-center  [&>li_a]:text-white  [&>li_a]:block [&>li_a]:sm:py-4 [&>li_a]:sm:px-6 [&>li_a]:p-3 [&>li_a]:capitalize [&>li_a]:bg-transparent [&>li_a]:border-[1px] [&>li_a]:border-[white] [&>li_a]:rounded-[30px] [&>li_a]:[transistion:all] [&>li_a]:duration-150 [&>li_a]:ease-linear [&>li_a]:HoverDarker ">
            <li className="">
              <NavLink
                to={`${username}/current-goals`}
                className={(NavLink) =>
                  NavLink.isActive
                    ? " !bg-[rgba(1,255,143,1)]  !text-black !border-transparent    "
                    : " hover:!bg-[rgba(1,255,143,1)] hover:!text-black hover:!border-transparent  "
                }
              >
                See All Goals
              </NavLink>
            </li>
          </ul>
        </div>
        <GeneralTipCard text="Send a tip to Velo City here" />
      </div>

      {/* Right Panel - Leaderboard */}
      <ColorLeaderBoard />
    </div>
  );
}

export default ForOtherUserOnly;
